import { NonCopyableMarkdown, SectionWrapper } from '../common';

export default function TextSection({
  content,
  style,
}: {
  content: string;
  style?: React.CSSProperties;
}) {
  return (
    <SectionWrapper style={style}>
      <NonCopyableMarkdown md={content} />
    </SectionWrapper>
  );
}
